document.addEventListener('DOMContentLoaded', () => {
    const contactButtons = document.querySelectorAll('.card-contact-btn');
    const closeBtn = document.querySelector('.close-modal .close-btn');
    const modal = document.querySelector('.modal-quick-book-a-meeting');
    const form = document.querySelector('.detail-form');

    contactButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        console.log('Clicking card contact button');

        if (!modal || !form) return;

        // 🚫 Bloquear redirección solo en desktop
        if (window.innerWidth >= 1024) {
          e.preventDefault();
        }

        if (window.innerWidth < 1024) {
          modal.classList.add('mobile-show');
          requestAnimationFrame(() => {
            form.classList.add('mobile-show');
            document.body.style.overflow = 'hidden';
          });
        } else {
          modal.classList.add('desktop-show');
          document.body.style.overflow = 'hidden';
        }

        document.querySelector('.zsiq_floatmain.zsiq_theme1.siq_bR').style.setProperty('display', 'none', 'important');

      });
    });

    // Cerrar modal
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        if (window.innerWidth < 1024) {
          form.classList.remove('mobile-show');
          modal.classList.remove('mobile-show');
          document.body.style.overflow = 'inherit';
          document.querySelector('.zsiq_floatmain.zsiq_theme1.siq_bR').style.setProperty('display', 'block', 'important');
        } else {
          modal.classList.remove('desktop-show');
          document.body.style.overflow = 'inherit';
          document.querySelector('.zsiq_floatmain.zsiq_theme1.siq_bR').style.setProperty('display', 'block', 'important');
        }
      });
    }

    // close when clicked outside
    if (modal && form) {
      modal.addEventListener('click', (e) => {
        if (!form.contains(e.target)) {
          if (window.innerWidth < 1024) {
            form.classList.remove('mobile-show');
            modal.classList.remove('mobile-show');
            document.body.style.overflow = 'inherit';
            document.querySelector('.zsiq_floatmain.zsiq_theme1.siq_bR').style.setProperty('display', 'block', 'important');
          } else {
            modal.classList.remove('desktop-show');
            document.body.style.overflow = 'inherit';
            document.querySelector('.zsiq_floatmain.zsiq_theme1.siq_bR').style.setProperty('display', 'block', 'important');
          }
        }
      });
    }

});

(function() {
  // Texto y clase del nuevo subtitle
  const subtitleText = 'Let our specialists assist you in choosing your next piece';
  const subtitleClass = 'modal-subtitle';

  // Selector del header que queremos esperar
  const headerSelector = '.klaviyo-form-V77Gj7 #rich-text-01KCHHJDA6V4PCB7GGDVK87CN1';

  // Función que intenta insertar el subtitle si el header existe
  function tryInsertSubtitle() {
    const header = document.querySelector(headerSelector);
    if (header && !document.querySelector('.' + subtitleClass)) {
      document.querySelector(headerSelector).querySelector('pre').querySelector('span').textContent = 'CONTACT FOR DETAILS';
      const p = document.createElement('p');
      p.textContent = subtitleText;
      p.classList.add(subtitleClass);
      header.insertAdjacentElement('afterend', p); // insertarlo después del h
      header.parentElement.classList.add('PDM-layout');
      return true;
    }
    return false;
  }



  // Si ya está disponible, lo insertamos sin esperar
  if (tryInsertSubtitle()) return;

  // MutationObserver para esperar al header
  const observer = new MutationObserver(() => {
    if (tryInsertSubtitle()) observer.disconnect(); // Stop when added
  });

  // Observamos todo el body porque Klaviyo inyecta dinámicamente el form
  observer.observe(document.body, { childList: true, subtree: true });
})();
